import { Gift, Rocket, TrendingUp, Coins } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PRODUCT_IMG } from "@/lib/constants";
import { useLang } from "@/i18n/LanguageContext";

export function WhyCollaborate() {
  const { t } = useLang();
  return (
    <section id="why" data-testid="why-section" className="relative z-10 bg-[#050505] py-24 md:py-36">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="max-w-3xl mb-16 md:mb-20">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">{t("why.overline")}</span>
          <h2 className="font-display font-bold tracking-[-0.02em] text-white text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.02]">
            {t("why.heading")}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-5 auto-rows-[minmax(220px,auto)]">
          <Reveal className="md:col-span-4 md:row-span-2" delay={0.05}>
            <article data-testid="why-card-products" className="group relative h-full overflow-hidden rounded-2xl border border-aura-border bg-aura-surface hover:border-aura-borderhover transition-colors duration-300">
              <img src={PRODUCT_IMG} alt="AURA+" className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-40 group-hover:scale-105 transition-[opacity,transform] duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-transparent" />
              <div className="relative h-full p-8 md:p-10 flex flex-col justify-end">
                <Gift className="text-white mb-5" size={28} />
                <h3 className="font-display text-2xl md:text-3xl font-semibold text-white">{t("why.products.title")}</h3>
                <p className="mt-3 text-zinc-400 max-w-md leading-relaxed">{t("why.products.desc")}</p>
              </div>
            </article>
          </Reveal>

          <Reveal className="md:col-span-2" delay={0.1}>
            <article data-testid="why-card-access" className="group h-full rounded-2xl border border-aura-border bg-aura-surface p-8 hover:border-aura-borderhover hover:-translate-y-1 transition-[transform,border-color] duration-300 flex flex-col">
              <Rocket className="text-white mb-5" size={26} />
              <h3 className="font-display text-xl md:text-2xl font-semibold text-white">{t("why.access.title")}</h3>
              <p className="mt-3 text-zinc-400 text-sm leading-relaxed">{t("why.access.desc")}</p>
            </article>
          </Reveal>

          <Reveal className="md:col-span-2" delay={0.15}>
            <article data-testid="why-card-growth" className="group h-full rounded-2xl border border-aura-border bg-aura-surface p-8 hover:border-aura-borderhover hover:-translate-y-1 transition-[transform,border-color] duration-300 flex flex-col">
              <TrendingUp className="text-white mb-5" size={26} />
              <h3 className="font-display text-xl md:text-2xl font-semibold text-white">{t("why.growth.title")}</h3>
              <p className="mt-3 text-zinc-400 text-sm leading-relaxed">{t("why.growth.desc")}</p>
            </article>
          </Reveal>

          <Reveal className="md:col-span-6" delay={0.2}>
            <article data-testid="why-card-earn" className="group h-full rounded-2xl border border-emerald-500/25 bg-emerald-500/[0.04] p-8 md:p-10 hover:border-emerald-500/40 transition-colors duration-300 flex flex-col md:flex-row md:items-center gap-5">
              <div className="shrink-0 h-14 w-14 rounded-2xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
                <Coins className="text-emerald-300" size={26} />
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl font-semibold text-white">{t("why.earn.title")}</h3>
                <p className="mt-2 text-zinc-400 leading-relaxed max-w-3xl">{t("why.earn.desc")}</p>
              </div>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
